import * as TYPES from './types'

/**
 * Default SlackOAuth State
 */
export const defaultState: TYPES.SlackOAuthState = {
  httpInProgress: false,
  httpUpdateInProgress: false,
  httpError: ''
}

// define initial state object
const initialState: TYPES.SlackOAuthState = {
  httpInProgress: defaultState.httpInProgress,
  httpUpdateInProgress: defaultState.httpUpdateInProgress,
  httpError: defaultState.httpError
}

// define slackOAuth reducer
export function slackOAuthReducer (
  state = initialState,
  action: TYPES.SlackOAuthActionTypes
): TYPES.SlackOAuthState {
  switch (action.type) {
    case TYPES.SLACKOAUTH_IN_PROGRESS: {
        return {
            ...state,
            ...{ httpInProgress: true, httpUpdateInProgress:false, httpError: '' }
      }
    }
    case TYPES.SLACKOAUTH_UPDATE_IN_PROGRESS: {
      return {
          ...state,
          ...{ httpInProgress: false, httpUpdateInProgress:true, httpError: '' }
    }
  }
    case TYPES.SLACKOAUTH_ERROR: {
        return {
            ...state,
            ...{ httpInProgress: false, httpUpdateInProgress:false, httpError: action.error }
        }
    }
    case TYPES.SLACKOAUTH_SUCCESS: {
        return {
          ...state,
          ...{ httpInProgress: false, httpUpdateInProgress:false, httpError: '' }
        }
    }
    default:
        return state
  }
}
